import { storage } from '@doxyme/ui/utils';
import { languageOptions } from '@doxyme/ui/config';

export const filterPreviousSelectedLanguages = (
  localStorageKey: string,
): string[] => {
  let currentValue = storage.getItem<string[]>(localStorageKey, true) ?? [];
  if (currentValue.length > 0) {
    const filtered = currentValue.filter((prevLang: string) =>
      languageOptions.some((langOpt) => langOpt.value === prevLang),
    );
    if (filtered.length !== currentValue.length) {
      storage.setItem(localStorageKey, filtered, true);
    }
    currentValue = filtered;
  }
  return currentValue;
};
